<div class="error-container d-flex flex-column justify-content-center align-items-center vw-100 vh-100">

    <div class="text-center mb-3">
        <span [innerHTML]="notAvailableMessage"></span>
    </div>

    <a class="btn button-accent-color text-decoration-none py-2 px-3" [routerLink]="returnButtonUrl">
        <fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>
        <span class="fs-5">{{returnButtonText}}</span>
    </a>

</div>
